export const UPDATE_STATUS_INVENTORY = {
	REQUEST: 'UPDATE_STATUS_INVENTORY.REQUEST',
	SUCCESS: 'UPDATE_STATUS_INVENTORY.SUCCESS',
	FAILED: 'UPDATE_STATUS_INVENTORY.FAILED',
};
